HeaderWrapperController.$inject = ["$route", "$auth", "$location", "$window", "$rootScope", "$scope", "$state", "$translate", "$translatePartialLoader", "$transitions", "authorizationKeys", "environmentVariables", "headerLocalizationPath", "localePaths", "logger", "menu", "modules", "dealerCountries", "authorizationService", "crossDomainStorageService", "dealSheetService", "dealerService", "globalIframeService", "legacyService", "menuService", "storageService", "tokenService", "userService", "vehicleService"];
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.object.set-prototype-of.js";
/* injects from baggage-loader */
require('./header-wrapper.component.html');
import angular from 'angular';
import _ from 'lodash';
import { RejectType } from '@uirouter/core';
import { resizeHeader, showAutoAlertiFrame } from '../scripts/init';
import { loggedIn$, externalLoggedIn$ } from '../modules/oidc-auth/events';
import defaultLogoPath from '../images/autoalert-logo.png';
import fordLogoPath from '../images/autoalert-logo-ford.png';
import lincolnLogoPath from '../images/autoalert-logo-lincoln.png';
import { ProductTypes as productTypes } from '../constants';
import fordCanadaLogoPath from '../images/autoalert-logo-ford-canada.png';
import lincolnCanadaLogoPath from '../images/autoalert-logo-lincoln-canada.png';
angular.module('AaApp.Opp').component('headerWrapper', {
  templateUrl: '/app/components/header-wrapper.component.html',
  controller: HeaderWrapperController
});

/* @ngInject */
function HeaderWrapperController(
// AngularJS stuff
$route, $auth, $location, $window, $rootScope, $scope, $state, $translate, $translatePartialLoader, $transitions,
// Configuration
authorizationKeys, environmentVariables, headerLocalizationPath, localePaths, logger, menu, modules, dealerCountries,
// Services
authorizationService, crossDomainStorageService, dealSheetService, dealerService, globalIframeService, legacyService, menuService, storageService, tokenService, userService, vehicleService) {
  var $ctrl = this;
  $ctrl.state = $state;
  $ctrl.hasInventoryAccess = false;
  $ctrl.isEuroLite = false;
  $ctrl.isHeaderVisible = false;
  $ctrl.isAuthenticated = false;
  $ctrl.dealerListDisabled = false;
  $ctrl.onDealersChanged = onDealersChanged;
  $ctrl.onCustomerEngagementClicked = onCustomerEngagementClicked;
  $ctrl.logoPath;
  $ctrl.version = environmentVariables.version;
  $ctrl.$onInit = $onInit;
  $ctrl.$onDestroy = $onDestroy;
  $ctrl.showSubmenu;
  $ctrl.productTypes = productTypes;
  $ctrl.userProfileMenuItems = getFilteredUserMenu();
  externalLoggedIn$.subscribe(function (e) {
    $onInit();
  });
  loggedIn$.subscribe(function (e) {
    $onInit();
  });
  $transitions.onEnter({}, function (transition) {
    disableDealerList(transition.to().name);
  });
  function disableDealerList(stateName) {
    var isDealSheetPage = stateName.toLowerCase().indexOf('dealsheet') > -1;
    $ctrl.dealerListDisabled = isDealSheetPage;
  }
  function onCustomerEngagementClicked(engagement) {
    dealSheetService.openDealSheetModal(engagement.opportunityId);
  }
  function onDealersChanged(_x, _x2, _x3, _x4) {
    return _onDealersChanged.apply(this, arguments);
  }
  function _onDealersChanged() {
    _onDealersChanged = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dealerGroupId, dealerIds, dealers, dealerDisplayText) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return dealerService.updateSelectedDealers(dealers, dealerGroupId, dealerDisplayText);
          case 1:
            // Don't display the "dealer changed" message in this window.
            try {
              $ctrl.selectedDealerIdsSubscription.unsubscribe();
            } catch (e) {
              logger.debug(e);
            }

            // The page will refresh upon receipt of the message Legacy sends
            // in response to this call.
            legacyService.sendChangeDealerMessageToIframe(dealerIds);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _onDealersChanged.apply(this, arguments);
  }
  $ctrl.isProcessingAuthCallback = $location.path().indexOf('/auth/callback') > -1;
  if ($ctrl.isProcessingAuthCallback) return;
  function $onInit() {
    $ctrl.disposeSiteMapLoaded = $rootScope.$on('RUN_USER_INIT.SITE_MAP_READY', function onSiteMapLoaded() {
      $ctrl.hasInventoryAccess = authorizationService.isAuthorized(authorizationKeys.Inventory);
      updateSelectedDealers();
      $ctrl.isEuroLite = authorizationService.isEuroLite();
      // Start this call immediately in case we need it
      var availableMakesPromise = vehicleService.getMakes($ctrl.dealerIds || [], null);
      userService.getUserProfile().then(function getUserProfileComplete(userProfile) {
        getLogoPath(userProfile.dealerModules, availableMakesPromise, userProfile.countryId).then(function (logoPath) {
          return $ctrl.logoPath = logoPath;
        });
        $ctrl.userProfile = userProfile;
        $ctrl.isEulaAccepted = userProfile.eulaAcceptedDate != null;
        var dealerIDs = dealerService.getSelectedDealerIds();
        if (Array.isArray(dealerIDs) && dealerIDs.length) dealerService.getDealerSettings(dealerIDs[0]).then(function (settings) {
          $ctrl.productId = settings.productID;
          $ctrl.userProfileMenuItems = getFilteredUserMenu($ctrl.isAuthenticated, $ctrl.userProfile);
        });
        $translatePartialLoader.addPart(headerLocalizationPath);
        $translatePartialLoader.addPart(localePaths.general);
        resizeHeader($state.$current, globalIframeService);
        $rootScope.$broadcast('RUN_USER_INIT.REPOSITION_UI_VIEW');
        if (userProfile.walkmeSegments && userProfile.walkmeSegments.length > 0) {
          window.AA_WalkMe_Segments = {};
          userProfile.walkmeSegments.forEach(function (segment) {
            window.AA_WalkMe_Segments[segment.SegmentId] = segment.SegmentValue;
          });
        }
        $ctrl.isCoreReady = true;
        $ctrl.menu = menu;
      });
    });
    $transitions.onSuccess({}, function (transition) {
      setSelectedTab();
      $ctrl.userProfileMenuItems = getFilteredUserMenu($ctrl.isAuthenticated, $ctrl.userProfile);
    });
    $ctrl.IsVisible = true;
    $ctrl.recentDealSheetsVisible = false;
    $ctrl.menu = menu;
    $ctrl.isReportTabEnabled = false;
    setSelectedTab();
    $ctrl.searchPresetsVisible = false;
    var isPublicState = $state.current.access == 'public'; // always false at this point in the cycle
    $ctrl.isAuthenticated = $auth.isAuthenticated();
    $ctrl.userProfileMenuItems = getFilteredUserMenu($ctrl.isAuthenticated, $ctrl.userProfile);
    $ctrl.isHeaderVisible = (isPublicState || $ctrl.isAuthenticated) && $ctrl.IsVisible == true;
    $ctrl.isEulaAccepted = false;
    var url = $location.url();
    var hiddenHeaderUrls = ["auto-check", "car-fax", "carfax-authorize", "cfcallback", "car-proof", "template-email-preview", "mobile/deal-sheet"];
    for (var _i = 0, _hiddenHeaderUrls = hiddenHeaderUrls; _i < _hiddenHeaderUrls.length; _i++) {
      var urlPortion = _hiddenHeaderUrls[_i];
      if (url.includes(urlPortion)) {
        $ctrl.isHeaderVisible = false;
        break;
      }
    }
    if (!$ctrl.isHeaderVisible) $ctrl.logoPath = defaultLogoPath;
    disableDealerList($state.$current.name);
    $ctrl.selectedDealerIdsSubscription = crossDomainStorageService.onchange('selectedDealers', function () {
      updateSelectedDealers();
    });
    if (url.includes("/email/") && url.includes("code=")) {
      // for Customer Unsubscribe and View In Browser sent emails
      $ctrl.isHeaderVisible = false;
    }
    function setSelectedTab() {
      $ctrl.selectedTab = $state.includes('reportsContainer') ? 'reports' : 'opportunities';
      if ($ctrl.selectedTab == 'reports') {
        $ctrl.showSubmenu = false;
      } else {
        $ctrl.showSubmenu = true;
      }
    }

    // check if slt user and page is conquests
    if ($location.url().indexOf("conquests") > -1 && storageService.getItem('userProfile').isSltUser) $ctrl.isQuickSearchVisible = false;else $ctrl.isQuickSearchVisible = true;
  }
  function $onDestroy() {
    $ctrl.disposeSiteMapLoaded();
    if ($ctrl.selectedDealerIdsSubscription) {
      $ctrl.selectedDealerIdsSubscription.unsubscribe();
    }
  }
  function updateSelectedDealers() {
    $ctrl.dealerGroupId = dealerService.getSelectedDealerGroupId();
    $ctrl.dealerIds = dealerService.getSelectedDealerIds();
    $ctrl.dealers = dealerService.getSelectedDealers();
    $ctrl.dealerDisplayText = dealerService.getDealerDisplayText();
  }
  function getFilteredUserMenu(isAuthenticated, userProfile) {
    var allItems = [{
      type: $state.current.name != 'userProfile' ? 'SREF' : '',
      translate: 'myProfile',
      sref: 'userProfile'
    }, {
      type: 'SEPARATOR'
    }];
    if (isAuthenticated != undefined && !isAuthenticated) {
      allItems.push({
        type: 'HREF',
        translate: 'login',
        icon: 'aa-icon-login',
        href: '#',
        action: function action() {
          legacyService.sendLogOutMessage();
          $auth.signIn();
        }
      });
    } else {
      allItems.push({
        type: 'HREF',
        translate: 'logout',
        icon: 'aa-icon-logout',
        href: '#',
        action: function action() {
          $auth.signOut();
        }
      });
    }
    if ($ctrl.productId && $ctrl.productId == productTypes.euroLite) {
      allItems = _.filter(allItems, function (item) {
        return item.translate != 'requestCallBack';
      });
    }
    if (isAuthenticated && userProfile && userProfile.userFullName) {
      return allItems;
    } else {
      // Remove My Profile
      return allItems.slice(1);
    }
  }
  function getLogoPath(moduleIds, availableMakesPromise, countryId) {
    if (!moduleIds || moduleIds.length === 0) {
      return Promise.resolve(defaultLogoPath);
    }
    var hasFordAlertModule = moduleIds.some(function (o) {
      return o.moduleID === modules.fordAlert;
    });
    if (!hasFordAlertModule) {
      return Promise.resolve(defaultLogoPath);
    }
    return availableMakesPromise.then(function (availableMakes) {
      // A dealer is a "Lincoln-only" dealer if they:
      //   1. Have the FordAlert module
      //   2. Have Lincoln as a DealerMake
      //   3. Do NOT have Ford as a DealerMake
      var fordMakeIds = environmentVariables.fordMakeIds || [];
      var lincolnMakeIds = environmentVariables.lincolnMakeIds || [];
      var isLincolnDealer = availableMakes.some(function (m) {
        return lincolnMakeIds.includes(m.makeID);
      });
      var isFordDealer = availableMakes.some(function (m) {
        return fordMakeIds.includes(m.makeID);
      });
      var fordlogo = fordLogoPath;
      var lincolnlogo = lincolnLogoPath;

      // if canada then update logo images
      if (countryId == dealerCountries.canada) {
        fordlogo = fordCanadaLogoPath;
        lincolnlogo = lincolnCanadaLogoPath;
      }
      return isLincolnDealer && !isFordDealer ? lincolnlogo : fordlogo;
    });
  }
  $scope.$watch('$ctrl.isCoreReady', function () {
    var cultureName = storageService.getItem('cultureName');
    if (cultureName) {
      $translate.use(cultureName);
    }
  });
  globalIframeService.subscribe(function (_ref, replyPort) {
    var data = _ref.data;
    if (data['AUTOALERT_IFRAME_LOADED']) {
      // AA is ready show iframe
      $ctrl.IsVisible = true;
      $ctrl.isHeaderVisible = true;

      //todo: iframe code ---- remove when iframe is gone!
      showAutoAlertiFrame($state.$current);
      resizeHeader($state.$current, replyPort);
    } else if (data['EULA_ACCEPT']) {
      $ctrl.isEulaAccepted = true;
      storageService.setItem('userProfile', null);
      userService.getUserProfile().then(function (userProfile) {
        // no need to update profile since we have already set $ctrl.isEulaAccepted to true;
        // we need to call this so next time user logs in he gets data from updated DB not the cache.
      });
    } else if (data['EULA_DECLINE']) {
      $ctrl.isEulaAccepted = false;
      $state.go('errorUnauthorized', {
        errorState: 'marketingSplash'
      });
    } else if (data['PROFILE_UPDATED']) {
      storageService.setItem('userProfile', null);
      // getUserProfile(true) means force reload from the server
      userService.getUserProfile(true).then(function (profile) {
        if (profile) if ($ctrl.userProfile) $ctrl.userProfile.userFullName = profile.userFullName;
      });
    }
  });
}